import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { take } from 'rxjs';
import { AgencyService } from 'src/app/services/agency.service';

@Component({
  selector: 'ness-merge-agencies',
  templateUrl: './merge-agencies.component.html'
})
export class MergeAgenciesComponent  {

  @Input() selectedAgencies: ServerModels.UpdateAgencyViewModel[] = [];
  @Output() closeMergeForm = new EventEmitter();
  @Output() onMerge = new EventEmitter();

  parentAgency: ServerModels.UpdateAgencyViewModel = null;
  cols: any[] = [
    { header: 'Agency Name', field: 'ENESS_REF_Agency.AgencyName' },
    { header: 'ORI Number', field: 'ENESS_REF_Agency.ENESS_XREF_AgencyOriNum.OriNum' },
    { header: 'Field Division', field: 'ENESS_REF_FieldDivisions.FieldDivisionName' },
    { header: 'Field Division Group', field: 'ENESS_XREF_AgencyFieldDivisionGroups.ENESS_REF_IntelligenceReportATFReferralGroups.GroupName' },
    { header: 'State', field: 'ENESS_REF_Agency.ENESS_REF_Counties.ENESS_REF_State.StateName' },
    { header: 'County', field: 'ENESS_REF_Agency.ENESS_REF_Counties.CountyName' }
  ];

  constructor(
    private agencyService: AgencyService,
    public messageService: MessageService
  ) { }

  public closeForm() {
    this.messageService.clear();
    this.selectedAgencies = [];
    this.closeMergeForm.emit();
  }


  public mergeAgencies(): void {
    if (this.selectedAgencies.length != 2 || !this.parentAgency) {
      this.messageService.add({
        key: 'oriMergeMessage',
        severity: 'error',
        summary: 'Error',
        detail: 'Merge agencies requires two agencies with one agency selected as the merge target.'
      });
      return;
    }

    let mergeAgencyId = this.selectedAgencies.find(x => x.AgencyID != this.parentAgency.AgencyID);

    this.agencyService.mergeAgencyORINums(this.parentAgency.AgencyID, mergeAgencyId?.AgencyID).pipe(take(1)).subscribe(
      (mergedAgency: ServerModels.UpdateAgencyViewModel) => this.onMerge.emit()
    );
  }  
}
